module.exports = __webpack_public_path__ + "img/ic-filter-previous.6e9eb56a.svg";